import { createContext, useContext, useEffect, useState } from "react";
import { requestCategories, requestDeletedCategories, requestDeletedPriorityLevels, requestDeletedServers, requestPriorityLevels, requestServers } from "../requests/setup_requests";
import { loadingActive } from "../components/Background";
import { BanErrorModal, GenericErrorModal } from "../components/ErrorComponents";
import { useTranslation } from "react-i18next";


const ContentContext = createContext();

let copyTimer = null

const ContentController = (props) => {
    const [categories, setCategories] = useState({})
    const [deletedCategories, setDeletedCategories] = useState({})
    const [priorities, setPriorities] = useState({})
    const [deletedPriorities, setDeletedPriorities] = useState({})
    const [servers, _setServers] = useState({})
    const [deletedServers, _setDeletedServers] = useState({})
    const [ready, setReady] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [banErrorMessage, setBanErrorMessage] = useState(null)
    const [isDarkMode, setIsDarkMode] = useState(
        localStorage.getItem("theme") === "dark" ||
        (!("theme" in localStorage) &&
            window.matchMedia("(prefers-color-scheme: dark)").matches)
    );
    const { t } = useTranslation('common')

    const [copied, setCopied] = useState(false)

    const handleCopyToClipboard = async (textToCopy) => {
        try {
            if (copyTimer) {
                clearTimeout(copyTimer)
            }
            await navigator.clipboard.writeText(textToCopy); // Copies text to clipboard
            setCopied(textToCopy);
            copyTimer = setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
        } catch (err) {
            console.error("Failed to copy text: ", err);
        }
    }

    const _setCategories = (catsData) => {
        let cats = {}
        catsData.forEach(element => {
            cats[element.id] = element
        });
        setCategories(cats)
    }

    const _setDeletedCategories = (catsData) => {
        let cats = {}
        catsData.forEach(element => {
            cats[element.id] = element
        });
        setDeletedCategories(cats)
    }

    const setPriorityLevels = (prioData) => {
        let prios = {}
        prioData.forEach(element => {
            prios[element.id] = element
        });
        setPriorities(prios)
    }

    const setDeletedPriorityLevels = (prioData) => {
        let prios = {}
        prioData.forEach(element => {
            prios[element.id] = element
        });
        setDeletedPriorities(prios)
    }

    const setServers = (serverData) => {
        let servs = {}
        serverData.forEach(element => {
            servs[element.id] = element
        });
        _setServers(servs)
    }

    const setDeletedServers = (serverData) => {
        let servs = {}
        serverData.forEach(element => {
            servs[element.id] = element
        });
        _setDeletedServers(servs)
    }

    useEffect(() => {
        loadingActive(true)
        requestCategories({})
            .then((data) => {
                _setCategories(data.categories)
            })
        requestDeletedCategories({})
            .then((data) => {
                _setDeletedCategories(data.deleted_categories)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
        requestPriorityLevels({})
            .then((data) => {
                setPriorityLevels(data.priority_levels)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
        requestDeletedPriorityLevels({})
            .then((data) => {
                setDeletedPriorityLevels(data.deleted_priority_levels)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
        requestServers({})
            .then((data) => {
                let servs = {}
                data.servers.forEach(element => {
                    servs[element.id] = element
                })
                _setServers(servs)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
        requestDeletedServers({})
            .then((data) => {
                let servs = {}
                data.servers.forEach(element => {
                    servs[element.id] = element
                })
                _setDeletedServers(servs)
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
    }, [])

    const openErrorModal = (error) => {
        setErrorMessage(error)
        document.getElementById("generic-error-modal").showModal()
    }

    const openBanErrorModal = (error) => {
        setBanErrorMessage(error)
        document.getElementById("ban-error-modal").showModal()
    }

    useEffect(() => {
        if (Object.keys(categories).length > 0 && Object.keys(priorities).length > 0) {
            setReady(true)
        }
    }, [categories, priorities])


    useEffect(() => {
        if (ready) {
            loadingActive(false)
        }
    }, [ready])


    useEffect(() => {
        if (!ready) {
            console.error("Failed to load content info.")
        }
        else {
            console.info("Content info loaded.")
        }
    }, [ready])

    if (!ready) {
        return <div className="text-center content-center h-screen">{t("Failed to load account info.")}</div>
    }

    return (
        <ContentContext.Provider
            value={{
                categories,
                setCategories,
                priorities,
                setPriorities,
                servers,
                setServers,
                deletedServers,
                setDeletedServers,
                errorMessage,
                setErrorMessage,
                openErrorModal,
                _setCategories,
                setPriorityLevels,
                deletedCategories,
                deletedPriorities,
                isDarkMode,
                setIsDarkMode,
                copied,
                setCopied,
                handleCopyToClipboard,
                banErrorMessage,
                setBanErrorMessage,
                openBanErrorModal,
            }}
        >
            <GenericErrorModal />
            <BanErrorModal />
            {props.children}
        </ContentContext.Provider>

    )
}


export const useError = () => {
    const { openErrorModal } = useContext(ContentContext)
    return openErrorModal
}

export { ContentContext, ContentController };